<p-panel [toggleable]="true" [collapsed]="true"
         [header]="'user.account.subscriptionTab.invoices.panelTitle' | transloco"
         (onAfterToggle)="onPanelToggle($event.collapsed === false)"
         styleClass="invoices-panel">

    <div *ngIf="invoicesLoading" class="invoice-loading">
        <p-progressSpinner styleClass="small-spinner"></p-progressSpinner>
    </div>

    <div *ngIf="!invoicesLoading && invoicesError" class="invoice-empty">
        <i class="pi pi-exclamation-triangle"></i>
        <p>{{ 'user.account.subscriptionTab.invoices.loadError' | transloco }}</p>
        <button pButton type="button" [label]="'user.account.subscriptionTab.invoices.retry' | transloco" (click)="loadInvoices()"></button>
    </div>

    <div *ngIf="!invoicesLoading && !invoicesError && invoicesLoaded && invoices.length === 0" class="invoice-empty">
        <i class="pi pi-inbox"></i>
        <p>{{ 'user.account.subscriptionTab.invoices.empty' | transloco }}</p>
    </div>

    <p-table *ngIf="!invoicesLoading && !invoicesError && invoices.length > 0"
             [value]="invoices"
             [paginator]="invoices.length > 10"
             [rows]="10"
             styleClass="p-datatable-sm invoice-history-table">
        <ng-template pTemplate="header">
            <tr>
                <th>{{ 'user.account.subscriptionTab.invoices.colDate' | transloco }}</th>
                <th>{{ 'user.account.subscriptionTab.invoices.colPlan' | transloco }}</th>
                <th>{{ 'user.account.subscriptionTab.invoices.colAmount' | transloco }}</th>
                <th>{{ 'user.account.subscriptionTab.invoices.colNfStatus' | transloco }}</th>
                <th>{{ 'user.account.subscriptionTab.invoices.colActions' | transloco }}</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item>
            <tr>
                <td>{{ item.paidAt | date:'dd/MM/yyyy' }}</td>
                <td>
                    {{ displayName(item) }}
                    <p-tag [value]="typeLabel(item)" severity="secondary" styleClass="invoice-type-tag"></p-tag>
                </td>
                <td>{{ item.amount | currency: item.currency }}</td>
                <td>
                    <p-tag [value]="nfStatusLabel(item.nfStatus)" [severity]="nfStatusSeverity(item.nfStatus)"></p-tag>
                </td>
                <td>
                    <button pButton type="button" icon="pi pi-eye" class="p-button-text p-button-sm"
                            [pTooltip]="'user.account.subscriptionTab.invoices.viewDetails' | transloco"
                            (click)="viewDetails.emit(item.id)"></button>
                </td>
            </tr>
        </ng-template>
    </p-table>
</p-panel>
